// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";

import SignIn from "layouts/authentication/sign-in";
import Users from "layouts/users";
// @mui icons
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import Icon from "@mui/material/Icon";
import Products from "layouts/products";
import StoresOrders from "layouts/stores_orders";
import StoreProfile from "layouts/stores/StoreProfile";
import MyWallet from "layouts/myWallet";
import BankAccounts from "layouts/bankAccounts";
import Offers from "layouts/offers/offers";
import OffersIndex from "layouts/offers/index";
import ChatInterface from "layouts/chats";
import OrderPreview from "layouts/order_preview/OrderPreview";
import ShowSupscriptionDetails from "layouts/plans-subscriptions/ShowSupscriptionDetails";
import ReviewsIcon from "@mui/icons-material/Reviews";
import Ratting from "layouts/Ratting/Ratting";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import Ads from "layouts/ads";
const routes = [
  {
    type: "collapse",
    name: "الرئيسية",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "المستخدمين",
    key: "users",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/users",
    component: <Users />,
  },
  {
    type: "collapse",
    name: "الطلبات",
    key: "stores_orders",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/stores_orders",
    component: <StoresOrders />,
  },
  {
    type: "collapse",
    name: "الدردشات",
    key: "chats",
    icon: <Icon fontSize="small">chat</Icon>,
    route: "/chats",
    component: <ChatInterface />,
  },

  {
    type: "collapse",
    name: "المنتجات",
    key: "products",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/products",
    component: <Products />,
  },
  {
    type: "collapse",
    name: "الاعلانات",
    key: "ads",
    icon: <AdsClickIcon fontSize="small" />,
    route: "/ads",
    component: <Ads />,
  },
  {
    type: "collapse",
    name: "العروض الخاصة",
    key: "offers",
    icon: <Icon fontSize="small">local_offer</Icon>,
    route: "/offers",
    component: <OffersIndex />,
  },
  {
    type: "collapse",
    name: "الخطط والاشتراكات",
    key: "plans-subscriptions",
    icon: <ReceiptLongIcon fontSize="small" />,
    route: "/plans-subscriptions",
    component: <ShowSupscriptionDetails />,
  },
  {
    route: "/offers/new",
    component: <Offers />,
  },
  {
    type: "collapse",
    name: "التقييمات",
    key: "rattings",
    icon: <ReviewsIcon fontSize="small" />,
    route: "/rattings",
    component: <Ratting />,
  },
  {
    type: "collapse",
    name: "الاعدادات",
    key: "settings",
    icon: <Icon fontSize="small">person</Icon>,
    collapse: [
      // 👈 هنا نستخدم collapse بدل route
      {
        name: "الملف الشخصي",
        key: "store_profile",
        route: "/store_profile",
        component: <StoreProfile />,
      },
      {
        name: "محفظتي",
        key: "my_wallet",
        route: "/my_wallet",
        component: <MyWallet />,
      },
      {
        name: "حساباتي البنكية",
        key: "bank_accounts",
        route: "/bank_accounts",
        component: <BankAccounts />,
      },
    ],
  },

  {
    type: "collapse",
    name: "تسجيل دخول",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },

  {
    route: "/order-preview/:id",
    component: <OrderPreview />,
  },
];

export default routes;
